import { Menu as MUIMenu, type MenuProps } from '@mui/material';

export { type MenuProps } from '@mui/material';

export function Menu(props: MenuProps) {
  return <MUIMenu {...props} />;
}
